import { render, staticRenderFns } from "./declarationEdit.vue?vue&type=template&id=41a5d659&scoped=true"
import script from "./declarationEdit.vue?vue&type=script&lang=js"
export * from "./declarationEdit.vue?vue&type=script&lang=js"
import style0 from "./declarationEdit.vue?vue&type=style&index=0&id=41a5d659&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a5d659",
  null
  
)

export default component.exports